<script setup>
import CloseModalButton from "@Components/App/AppButtonCloseModal";

const props = defineProps({
    open: {type: Boolean, default: false},
    closable: {type: Boolean, default: true},
    closeClickOutside: { type: Boolean, default: true }
});
const emit = defineEmits(['close']);

const close = () => {
    if (props.closable) {
        emit('close');
    }
};
</script>
<template>
    <Transition name="modal-fade">
        <div class="v-modal-container" role="dialog" aria-modal="true" tabindex="-1" data-keyboard="false"
             v-if="props.open">
            <div class="v-modal-background"></div>
            <div class="v-modal-overlay">
                <div class="v-modal" @mousedown.self="closeClickOutside && close()">
                    <div class="v-modal-content">
                        <div class="close-button-container" v-if="closable" data-testid="modal-close-button">
                            <CloseModalButton @on-close-modal="close"/>
                        </div>
                        <slot/>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<style lang="scss">
@import '@Common/Styles/variables';

.v-modal-container {
    position: relative;
    z-index: 1000; // No choice because some elements in Yapla are already at 999

    &.modal-fade-enter-active,
    &.modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    &.modal-fade-enter-active .v-modal {
        transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
    }

    &.modal-fade-leave-active .v-modal {
        transition: transform 0.5s cubic-bezier(0.5, 0, 0.75, 0);
    }

    &.modal-fade-enter,
    &.modal-fade-leave-to {
        opacity: 0;
    }

    &.modal-fade-enter .v-modal {
        transform: translateY(-100px);
    }

    &.modal-fade-leave-to {
        .v-modal-overlay {
            overflow-y: hidden;
        }

        .v-modal {
            transform: translateY(100px);
        }
    }

    .v-modal-background, .v-modal-overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
    }

    .v-modal-background {
        background-color: rgba(0, 0, 0, 0.2);
        backdrop-filter: blur(5px);
    }

    .v-modal-overlay {
        z-index: 10;
        overflow-y: auto;

        .v-modal {
            will-change: transform;
            display: flex;
            min-height: 100%;
            align-items: center;
            justify-content: center;

            .v-modal-content {
                position: relative;
                border-radius: 6px;
                background-color: white;
                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
                padding: 30px;

                .close-button-container {
                    position: absolute;
                    top: 30px;
                    right: 30px;
                }
            }

        }
    }
}
</style>